import React from 'react';

const TextInput = ({ ...props }) => {
  return (
    <input
      type="text"
      {...props}
      className={`${props.className} 
        block w-full rounded border-0 p-2.5 ring-1 ring-gray-300 placeholder:text-gray-300 placeholder:font-regular focus:ring-2 focus:ring-gray-500 transition-all ease-in-out duration-200"
      `}
    />
  );
};

export default TextInput;
